import React from "react";
import {
    CanvasItem,
    ComponentType,
    ComponentIcon,
    AppMode,
    AppModeContext,
    TemplateContext,
} from "@emisgroup/clint-templates-common";
import "./templateNavigation.css";

type TemplateNavigationProps = {
    item: any;
};

const TemplateNavigation = ({ item }: TemplateNavigationProps) => {
    const { mode } = React.useContext(AppModeContext);
    const { selectedItem, setSelectedItem } = React.useContext(TemplateContext);
    const { panelName, members } = item;
    const isInRunMode = mode === AppMode.RUN;
    const isSelected = !isInRunMode && selectedItem.id === item.id;

    const handleClick = () => {
        setSelectedItem(item);
    };

    const renderIcons = (members: CanvasItem[]) => {
        if (members?.length) {
            return members.slice(0, 2).map(member => (
                <span key={member.id} className="icon" data-testid="sidebar-card-icon">
                    <ComponentIcon type={member?.type as ComponentType} />
                </span>
            ));
        }
        return null;
    };

    return (
        <a
            href={`#${item.id}`}
            className={`sidebar-card ${isSelected ? "selected" : ""}`}
            title={panelName || " "}
            data-testid="sidebar-card-wrapper"
            onClick={handleClick}
        >
            {renderIcons(members)}
            <span className="content" data-testid="sidebar-card-label">
                {panelName || <>&nbsp;</>}
            </span>
        </a>
    );
};

export default TemplateNavigation;
